import { render } from "./EditRequest6.vue?vue&type=template&id=42681f82"
import script from "./EditRequest6.vue?vue&type=script&lang=js"
export * from "./EditRequest6.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__